import React, {useEffect, useState} from 'react';
import {Alert, Button, SvgIcon, Tab, Tabs} from "@mui/material";
import BrandCreateUpdateForm from "./BrandCreateUpdateForm";
import localStrings from "../../../localStrings";
import {getUriSetting, saveUriSetting, SELECTED_TAB} from "../../../utils/optionsUriLocalStorage";
import SelectAmountToPay from "./SelectAmountToPay";
import PaymentList from "./PaymentList";
import ChargeHistory from "./ChargeHistory";
import useAuth from "../../../hooks/useAuth";
import BrandUsers from "./brandUsers";
import PageWithTitle from "../../../components/pages/pageWithTitle";
import {RouterLink} from "../../../components/router-link";
import {accountAddRoute, dashboardBaseRoute} from "../../../routes/dashboard";
import PlusIcon from "@untitled-ui/icons-react/build/esm/Plus";
import Markdown from "react-markdown";
import {needCreateBrandInfo} from "../../../mdContent/needCreateBrandInfo";

const AccountCreateUpdateView = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const tab = searchParams.get('tab');

  const {currentBrand, userInRole, superAdmin} = useAuth();
  const [currentTab, setCurrentTab] = useState(tab || getUriSetting(SELECTED_TAB) || 'general');
  const handleTabsChange = (event, value) => {
    saveUriSetting(SELECTED_TAB, value)
    setCurrentTab(value);
  };

  useEffect(() => {
    if (!currentBrand()) {
      setCurrentTab("general")
    }
  }, [])

  function getMainButtons() {
    if (superAdmin) {
      return (
        <RouterLink to={'/' + dashboardBaseRoute + '/' + accountAddRoute}
                    style={{ textDecoration: 'none' }}
        >
          <Button
            color="primary"
            variant="contained"
            startIcon={(
              <SvgIcon>
                <PlusIcon />
              </SvgIcon>
            )}
          >
            {localStrings.addAccount}
          </Button>
        </RouterLink>
      )
    }
    return null;

  }

  return (
    <PageWithTitle title={localStrings.account} mainButtons={getMainButtons()}>
        <>
          {!currentBrand() &&
            <Alert severity="warning">
              <Markdown children={needCreateBrandInfo}/>
            </Alert>
          }

          <Tabs
            onChange={handleTabsChange}
            scrollButtons="auto"
            value={currentTab}
            textColor="secondary"
            variant="scrollable"
          >
            <Tab label={localStrings.brand} value="general" />
            {/*{currentBrand() &&*/}
            {/*    <Tab label={localStrings.chargeMyAccount} value="chargeAccount" />*/}
            {/*}*/}
            {/*{currentBrand() &&*/}
            {/*  <Tab label={localStrings.paymentHistory} value="paymentList"/>*/}
            {/*}*/}
            {/*{currentBrand() &&*/}
            {/*    <Tab label={localStrings.chargeHistory} value="chargeHistory" />*/}
            {/*}*/}
            {currentBrand() &&
              <Tab label={localStrings.brandUsers} value="brandUsers" />
            }
          </Tabs>
          {currentTab === 'general' &&  <BrandCreateUpdateForm/>}
          {/*{currentTab === 'chargeAccount' &&  <SelectAmountToPay/>}*/}
          {/*{currentTab === 'paymentList' &&  <PaymentList/>}*/}
          {/*{currentTab === 'chargeHistory' &&  <ChargeHistory/>}*/}
          {currentTab === 'brandUsers' &&  <BrandUsers/>}
        </>
    </PageWithTitle>
  );
};

export default AccountCreateUpdateView;
